import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`text-xs font-mono font-medium uppercase tracking-[0.3em] text-gold ${className}`}
  >
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, children, id }) => (
  <div className="max-w-2xl" id={id}>
    <Reveal>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-midnight leading-[1.08]">
        {title}
      </h2>
      {children && (
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-charcoal/85">{children}</p>
      )}
    </Reveal>
  </div>
);
